import request from '../utils/request';
// url 比后台实际的RequestMapping多一个前缀 (此处多一个configuration)
// 此处多写一个前缀，是因为后台gateway模块拦截到请求会自动截掉第一个前缀
export default {
  test() {
    return request({
      url: `/configuration/configuration/test`,
      method: 'get'
    })
  },
   // 获取所有学校
   getSchools(params) {
    return request({
      url: `/configuration/configuration/getSchools`,
      method: 'get',
      params
    })
  },
  // 获取专业画像门类
  getCategory() {
    return request({
      url: `/configuration/configuration/getCategory`,
      method: 'get'
    })
  },
  // 获取专业画像门类专业类
  getProfessionClassByCode(code) {
    return request({
      url: `/configuration/configuration/getProfessionClassByCode?code=${code}`,
      method: 'get'
    })
  },
  // 获取专业画像专业信息
  getProfessionInfoByCode(code) {
    return request({
      url: `/configuration/configuration/getProfessionInfoByCode?professionClassCode=${code}`,
      method: 'get'
    })
  },
  // 获取学科评估门类
  getCategories() {
    return request({
      url: `/configuration/configuration/getCategories`,
      method: 'get'
    })
  },
  // 获取学科评估专业
  getMajorById(id) {
    return request({
      url: `/configuration/configuration/getMajorById?id=${id}`,
      method: 'get'
    })
  },
  // 获取学科评估结果
  getEstimateResultByName(name) {
    return request({
      url: `/configuration/configuration/getEstimateResultByName?name=${name}`,
      method: 'get'
    })
  },
  // 获取学校排名
  getSchoolRank(params) {
    return request({
      url: `/configuration/configuration/getSchoolRank`,
      method: 'get',
      params
    })
  },
  // 获取专业信息
  getProfession(code) {
    return request({
      url: `/configuration/configuration/getProfession?code=${code}`,
      method: 'get'
    })
  },
  // 获取专业满意度
  getProfessionSatisfaction(code) {
    return request({
      url: `/configuration/configuration/getProfessionSatisfaction?professionCode=${code}`,
      method: 'get'
    })
  },
  // 获取平均薪资和城市
  getSalaryAndPosition(code) {
    return request({
      url: `/configuration/configuration/getSalaryAndPosition?professionCode=${code}`,
      method: 'get'
    })
  },
  // 获取学校简介信息
  getSchoolBrief(schoolName) {
    return request({
      url: `/configuration/configuration/getSchoolBrief?schoolName=${schoolName}`,
      method: 'get',
    })
  },
  // 获取所有省份
  getProvinces() {
    return request({
      url: `/configuration/configuration/getProvinces`,
      method: 'get',
    })
  },
  // 获取所有学校类型
  getSchoolTypes() {
    return request({
      url: `/configuration/configuration/getSchoolTypes`,
      method: 'get',
    })
  },
  // 获取专业满意度top10
  getMajorSatisfaction(schoolName) {
    return request({
      url: `/configuration/configuration/getMajorSatisfaction?schoolName=${schoolName}`,
      method: 'get',
    })
  },
  // 获取专业推荐指数top10
  getMajorRecommendationIndex(schoolName){
    return request({
      url: `/configuration/configuration/getMajorRecommendationIndex?schoolName=${schoolName}`,
      method: 'get',
    })
  },
  // 获取推荐人数top10
  getMajorRecommendationNum(schoolName) {
    return request({
      url: `/configuration/configuration/getMajorRecommendationNum?schoolName=${schoolName}`,
      method: 'get',
    })
  },
  // 获取院校首页信息
  getSchoolHome(schoolName) {
    return request({
      url: `/configuration/configuration/getSchoolHome?schoolName=${schoolName}`,
      method: 'get',
    })
  },
  // 获取院校首页投票情况
  getSchoolVote(schoolName) {
    return request({
      url: `/configuration/configuration/getSchoolVote?schoolName=${schoolName}`,
      method: 'get',
    })
  },
  // 获取院校设置信息
  getSchoolFaculty(schoolName) {
    return request({
      url: `/configuration/configuration/getSchoolFaculty?schoolName=${schoolName}`,
      method: 'get',
    })
  }
}